import { CSSObject } from '@emotion/react';
import { useTheme } from '../../../../theme';
import { SubscriptionBadgeProps } from './subscriptionBadge';
import { badgeClasses } from '@mui/material/Badge';

type Props = Pick<SubscriptionBadgeProps, 'active' | 'size'>;

export const useSubscriptionBadgeStyles = ({
  active,
  size,
}: Props): CSSObject => {
  const theme = useTheme();

  const styles: Record<
    'subscriptionEnabled' | 'subscriptionDisabled',
    CSSObject
  > = {
    subscriptionEnabled: {
      backgroundColor: theme.badge.upgrade.active,
      color: theme.badge.upgrade.text,
      padding: `0 ${theme.spacing(2)}`,
      height: size === 'small' ? 16 : 20,
      borderRadius: theme.shape.radius12,
    },
    subscriptionDisabled: {
      backgroundColor: theme.badge.inactive.background,
      color: theme.badge.inactive.text,
      padding: `0 ${theme.spacing(2)}`,
      height: size === 'small' ? 16 : 20,
      borderRadius: theme.shape.radius12,
    },
  };

  return {
    [`.${badgeClasses.badge}`]: {
      ...(active ? styles.subscriptionEnabled : styles.subscriptionDisabled),
    },
  };
};
